import { FilePond, registerPlugin } from "react-filepond";

import "filepond/dist/filepond.min.css";
import "../../styles/fileUpload.scss";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// Plugins
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginPdfPreview from "filepond-plugin-pdf-preview";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";



// Register plugins once
registerPlugin(
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType,
    FilePondPluginPdfPreview,
    FilePondPluginImagePreview
);

export default function FileUpload({

    label = "Upload File",

    file,

    onChange,

    acceptedTypes = ['image/png', 'image/jpeg','application/pdf'],

    maxFileSize = "10MB",

    minFileSize = "1KB",

    error,

    allowMultiple = false

}) {

    return (

        <div className="fileUploadWrapper">

            <FilePond

                credits={false}

                files={file ? [file] : []}

                allowMultiple={allowMultiple}

                storeAsFile={true}

                allowFileTypeValidation={true}

                acceptedFileTypes={acceptedTypes}

                allowFileSizeValidation={true}

                maxFileSize={maxFileSize}

                minFileSize={minFileSize}

                allowPdfPreview={true}

                pdfPreviewHeight={390}

                labelMaxFileSizeExceeded="File is too large"

                labelIdle={`
                    <strong>${label}</strong><br/>
                    Drag & Drop or <span class="filepond--label-action">Browse</span>
                `}

                onupdatefiles={(items) => {

                    onChange(
                        items.length ? items[0].file : null
                    );

                }}

            />

            {error && (

                <div className="fileUploadError">
                    {error}
                </div>

            )}

        </div>

    );

}